import React, { useEffect, useCallback } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { colors } from '@mui/material';
import { Page, Header } from 'components';

import TechAddForm from './components/TechAddForm.js';
import CellInfoForm from './components/CellInfoForm.js';
import { GetTemplates } from '../../actions/TechAddActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const TechAdd = () => {
	const classes = useStyles();
	const dispatch = useDispatch();

	const getData = useCallback(() => {
		dispatch(GetTemplates());
	}, []);

	useEffect(() => {
		getData();
	}, []);

	return (
		<Page className={classes.root} title="Scripts">
			<Header module="Scripts" view="Tech Add" />
			<div className={clsx(classes.container)}>
				<TechAddForm />
				<CellInfoForm />
			</div>
		</Page>
	);
};

export default TechAdd;
